// extracted by css-extract-rspack-plugin
export default {"artlicleListEmpty":"artlicle-list-empty--OFG2pmcRRToifUbF","listItem":"list-item--cojvPyi2xe08fMBv"};